import React, { useState, useRef, useEffect } from "react";
import { endPoints, DefaultImageBaseurl } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import { Delete } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import moment from "moment-timezone";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import CreateBanner from "./CreateBanner";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Banner = () => {
  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [createBanner, setCreateBanner] = useState(false);
  const [images, setImages] = useState("");
  const [editData, setEditData] = useState({});

  let image_baseurl = `${endPoints.apiBaseUrl}`;

  // Avoid a layout jump when reaching the last page with empty rows.

  // console.log("image_baseurl",image_baseurl);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const DeleteBanner = (id) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELETE_BANNER}/${id}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);

        console.log("res", response);
        if (response.data.status === "success") {
          SuccesToast("Banner Deleted Successfully.");
          fetchUserData();
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const fetchUserData = async (data) => {
    let url = `${endPoints.api.GET_IMAGE}`;
    setIsLoading(true);
    await getAllData(url, data)
      .then((response) => {
        console.log("data", response.status);
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
          setImages(`${endPoints.api.GET_IMAGE}` / response.data.ba);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const onClose = () => {
    setCreateBanner(false);
    fetchUserData();
  };
  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Banner
                  </h3>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      setEditData({});
                      setCreateBanner(true);
                    }}
                  >
                    Add Banner
                  </Button>
                </div>
              </div>
              <CreateBanner
                open={createBanner}
                onClose={onClose}
                editData={editData}
              />

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Tittle</TableCell>
                            <TableCell align="center">Description</TableCell>
                            {/* <TableCell align="center">Link</TableCell> */}
                            <TableCell align="center">sort</TableCell>
                            <TableCell align="center">start date</TableCell>
                            <TableCell align="center">cutoff date</TableCell>
                            <TableCell align="center">Image</TableCell>
                            {/* <TableCell align="center">Code</TableCell>
                            <TableCell align="center">Price</TableCell>
                            <TableCell align="center">Player Count</TableCell>
                            <TableCell align="center">Active</TableCell> */}
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.idUser}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row.title}</TableCell>
                              <TableCell align="center">
                                {row.description}
                              </TableCell>

                              {/* <TableCell align="center">
                                {row.link}
                              </TableCell> */}

                              <TableCell align="center">{row.sort}</TableCell>

                              <TableCell align="center">
                                {moment
                                  .utc(row.startTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">
                                {moment
                                  .utc(row.endTime)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">
                                <img
                                  src={`${DefaultImageBaseurl}${row.banner_url}`}
                                  style={{ height: "70px" }}
                                />
                              </TableCell>
                              {/* <TableCell align="center">
                                $ {row.price}
                              </TableCell>
                              <TableCell align="center">
                                {row.player_count}
                              </TableCell> */}
                              {/* <TableCell align="center">
                                {row.isActive ? 'On' : 'Off'}
                              </TableCell> */}
                              <TableCell align="center">
                                {
                                  <div className="row">
                                    <div className="col-5">
                                      <AiOutlineEdit
                                        size={20}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setCreateBanner(true);
                                          setEditData(row);
                                        }}
                                      />
                                    </div>
                                    <div className="col-5">
                                      <span
                                        onClick={() => {
                                          DeleteBanner(row.id);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <Delete />
                                      </span>
                                    </div>
                                  </div>
                                }
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
